function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable react/prop-types */
import React from 'react';
import { compose } from 'recompose';
import { Notifier } from '@airbrake/browser';
import initialPropsContextEnhancer from "../InitialPropsContext/enhancer";
var ErrorMessage = function ErrorMessage() {
  return /*#__PURE__*/React.createElement("h1", null, "Something went wrong.");
};

// Class Component because of componentDidCatch and this.airbrake
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary() {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _possibleConstructorReturn(_this, (_this = _super.call.apply(_super, [this].concat(args)), _initialiseProps.call(_assertThisInitialized(_this)), _assertThisInitialized(_this)));
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      console.groupCollapsed('Component Error Boundary ERROR');
      console.log({
        error: error,
        info: info
      });
      console.groupEnd();
      this.setState({
        hasError: true
      });
      this.notify({
        error: error,
        params: {
          info: info,
          initial_props: this.props.initial_props
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        return /*#__PURE__*/React.createElement(ErrorMessage, null);
      }
      return this.props.children;
    }
  }]);
  return ErrorBoundary;
}(React.Component); // eslint-disable-next-line react/display-name
var _initialiseProps = function _initialiseProps() {
  var _this2 = this;
  this.state = {
    hasError: false
  };
  this.airbrake = function () {
    if (!_this2.airbrakeNotifier) {
      var _window;
      if (!window.AIRBRAKE_PROJECT_ID || !window.AIRBRAKE_PROJECT_KEY) return null;
      var projectId = typeof ((_window = window) === null || _window === void 0 ? void 0 : _window.AIRBRAKE_PROJECT_ID) !== 'number' ? parseInt(window.AIRBRAKE_PROJECT_ID, 10) : window.AIRBRAKE_PROJECT_ID;
      _this2.airbrakeNotifier = new Notifier({
        projectId: projectId,
        projectKey: window.AIRBRAKE_PROJECT_KEY
      });
    }
    return _this2.airbrakeNotifier;
  };
  this.notify = function () {
    var notifier = _this2.airbrake();
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (!notifier) {
      console.warn('cannot notify airbrake', args);
      return;
    }
    notifier.notify.apply(notifier, args);
  };
};
var errorBoundaryHOC = function errorBoundaryHOC(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(ErrorBoundary, {
      initial_props: props === null || props === void 0 ? void 0 : props.initial_props
    }, /*#__PURE__*/React.createElement(Component, props));
  };
};
var componentErrorBoundary = compose(initialPropsContextEnhancer('initial_props'), errorBoundaryHOC);
export default componentErrorBoundary;